import { render, staticRenderFns } from "./BuyoutBatchDetail.vue?vue&type=template&id=78c4c72e"
import script from "./BuyoutBatchDetail.vue?vue&type=script&lang=js"
export * from "./BuyoutBatchDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports